import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import MetaTags from 'react-meta-tags';

import error from '../../assets/images/error-img.png';

const Pages404 = () => {
  const { t: translate } = useTranslation();

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <MetaTags>
          <title>{translate('404 Error Page')} | Ectools</title>
        </MetaTags>
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="display-2 font-weight-medium">
                  4<i className="bx bx-buoy bx-spin text-primary display-3" />4
                </h1>
                <h4 className="text-uppercase">{translate('Sorry, page not found')}</h4>
                <div className="mt-5 text-center">
                  <Link className="btn btn-primary " to="/">
                    {translate('Back to Home')}
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages404;
